<div div class="container-fluid mt-4">
  <div class="row">
    <div class="col-xl-12 rowp">
      <div class="d-sm-flex d-block align-items-center mb-4">
        <div class="me-auto">
          <h2 class="ac-heading">
            Bill Analyst
            <span placement="right" ngbTooltip="Bill Analyst"
              ><svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 17H19V15H21M21 25H19V19H21M20 10C18.6868 10 17.3864 10.2587 16.1732 10.7612C14.9599 11.2638 13.8575 12.0003 12.9289 12.9289C11.0536 14.8043 10 17.3478 10 20C10 22.6522 11.0536 25.1957 12.9289 27.0711C13.8575 27.9997 14.9599 28.7362 16.1732 29.2388C17.3864 29.7413 18.6868 30 20 30C22.6522 30 25.1957 28.9464 27.0711 27.0711C28.9464 25.1957 30 22.6522 30 20C30 18.6868 29.7413 17.3864 29.2388 16.1732C28.7362 14.9599 27.9997 13.8575 27.0711 12.9289C26.1425 12.0003 25.0401 11.2638 23.8268 10.7612C22.6136 10.2587 21.3132 10 20 10Z"
                  fill="black"
                />
              </svg>
            </span>
          </h2>
        </div>
      </div>
      <div
        class="col-sm-12 col-md-8 ac-ff-inter fs-12 font-weight-lighter text-black instruction"
      >
        <p>
          You cannot use the Business Hub to make payments on invoices showing a
          zero balance, negative balance or on invoices billed in non-U.S.
          currency. To make a payment on invoices in non-U.S. currencies, print
          a remittance slip and mail your payment to the address shown.
        </p>
      </div>
      <div class="col-12 mt-4">
        <div class="table-actions">
          <h6 class="text-black font-w600 mb-3">Customer Number Selection</h6>
          <div class="invoice-search">
            <input
              type="text"
              class="search-box ac-custsearch"
              [(ngModel)]="customerIdSearch"
              placeholder="Search Customer Id."
              tabindex="0"
            />
          </div>
        </div>
        <p class="text-black font-w600 mt-4">
          Select the primary customer number you wish to use
        </p>
        <div *ngFor="let customerID of getCustomerIds; let i = index">
          <p *ngIf="customerID">
            <input
              type="radio"
              [value]="customerID"
              name="number"
              class="me-2"
              style="accent-color: currentColor"
              (change)="onRadioChange($event)"
            />{{ customerID }}
          </p>
        </div>
        <div *ngIf="isLoading" class="loading-overlay">
          <div class="spinner"></div>
        </div>
        <div class="form-group m-4 mt-4 pb-1" style="text-align: end">
          <button
            (click)="launchBillAnalyst(registrationStatus)"
            class="btn ac-btn-primary mb-sm-0 mb-2 float-right"
            [disabled]="isSubmitButtonDisabled"
          >
            Launch Bill Analyst
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-template #registrationStatus let-modal>
    <div class="modal-header" style="text-align: center">
      <h5 class="modal-title text- center">Registration Status</h5>
    </div>
    <div class="modal-body text-center">
      <p>{{ registrationMessage }}</p>
    </div>
    <div class="modal-footer ac-modelfooter mb-4">
      <button
        type="button"
        style="margin: 20px"
        class="btn btn-primary ac-btn-primary"
        (click)="modal.dismiss('Cross click')"
      >
        Close
      </button>
    </div>
  </ng-template>
</div>
